import { gql } from '@apollo/client';
import { GET_TOTEMS } from 'data/queries';
import { cache } from 'data/connection/client.connection';
import { TotemCreatedCacheHandlerParams } from 'types/cache.types';
import { TotemFragmentFragment as Totem } from 'data/__generated__';

export function totemCreatedCacheHandler({
    apolloClient,
    newTotem,
    updatedUser,
}: TotemCreatedCacheHandlerParams): void {
    const result = apolloClient.readQuery({
        query: GET_TOTEMS,
    });
    const totems = result?.totemsOfUser ?? [];
    apolloClient.writeQuery({
        query: GET_TOTEMS,
        data: { totemsOfUser: [...totems, newTotem as Totem] },
    });
    apolloClient.writeFragment({
        id: cache.identify(updatedUser),
        fragment: gql`
            fragment UserRoles on User {
                roles
            }
        `,
        data: {
            roles: updatedUser.roles,
        },
    });
}
